import canUseDom from '@argos/utils/esnext/canUseDom'
import { gethostPath } from '../helpers/ContentHelper'
import { getCleanPath } from '../helpers/pathCheck'
import { ARGOS_CARD_COOKIE } from '../helpers/abTestHelper'

const urlFormat = (fullLocation, variantTests = []) => {
  // help page magnolia point actually is `/features/help/...`
  if (fullLocation.split('/')[1] && fullLocation.split('/')[1] === 'help') {
    if (fullLocation.substr(-1) === '/') fullLocation = fullLocation.slice(0, -1)
    const helpLocation = fullLocation
      .split('/')
      .slice(2)
      .join('/')
    return `/features/${helpLocation}`
  }

  // a/b tests
  let variantUrl = ''
  variantTests.forEach((test) => {
    const { testName, testVal } = test

    // ARGOS CARD A/B Test
    if (testName === ARGOS_CARD_COOKIE && fullLocation.split('/')[2] && fullLocation.split('/')[2] === 'variants') {
      variantUrl = `/events/variants/${testVal}`
    }
  })
  if (variantUrl) return variantUrl

  // default cms path
  return fullLocation.split('?')[0]
}

async function fetchCmsApi(action) {
  const { historyData, location, timestamp, variantTests } = action
  // if data is already in state
  const apiLocation = getCleanPath(location)

  const canUseHistoryState = canUseDom() && historyData && historyData[apiLocation]
  if (canUseHistoryState) {
    return { data: historyData[apiLocation], status: 200 }
  }

  const timestampParam = timestamp ? `?for_date=${timestamp}` : ''
  const url = `${gethostPath()}global-api/cms`

  const fullUrl = `${url}${urlFormat(location, variantTests)}${timestampParam}`
  const res = await fetch(fullUrl)
  let data
  try {
    data = await res.json()
  } catch (err) {
    data = {}
  }

  const resObject = {
    data,
    status: res.status,
    statusText: res.statusText,
  }

  return resObject
}

export { urlFormat, fetchCmsApi }
